import { render, staticRenderFns } from "./SubmissionErrorList.vue?vue&type=template&id=3afbcacd&"
import script from "./SubmissionErrorList.vue?vue&type=script&lang=js&"
export * from "./SubmissionErrorList.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionErrorList.vue?vue&type=style&index=0&id=3afbcacd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports